import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import ModalWrapper from '../ModalWrapper';
import GoToProcessorPickerButton from 'payments-enrollment-embed-lib/buttons/GoToProcessorPickerButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CRMModal = props => {
  const {
    screen,
    handleInterstitialModalClose
  } = props;
  const Body = /*#__PURE__*/_jsxs(Text, {
    textAlign: "left",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "embedPoints.crmModal.processAndReportPayments"
    }), /*#__PURE__*/_jsxs(List, {
      styled: true,
      children: [/*#__PURE__*/_jsx(ListItem, {
        marginBlockStart: "800",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "embedPoints.crmModal.embedAPaymentLinkFromAnywhere"
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "embedPoints.crmModal.acceptPayments"
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "embedPoints.crmModal.increaseEfficiency"
        })
      })]
    })]
  });
  const Footer = /*#__PURE__*/_jsx(GoToProcessorPickerButton, {
    use: "primary",
    external: true,
    openInCommerceHome: true,
    sourceApp: screen,
    location: "embed-point-pre-enroll-modal",
    block: true
  });
  return /*#__PURE__*/_jsx(ModalWrapper, {
    onClose: handleInterstitialModalClose,
    modalName: "crmModal",
    Body: Body,
    Footer: Footer,
    illustrationName: "payments",
    modalSubTitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "embedPoints.crmModal.enrollInHubSpotPayments"
    }),
    paddingBlockStart: "1200",
    paddingBlockEnd: "500",
    paddingInlineEnd: "1000"
  });
};
export default CRMModal;